import { Component, Input, OnChanges, OnInit, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { CatalogSeoLinksResponse, CatalogSeoLinkCandidates } from '@vestiaire/api-sdk-angular';

export interface ISeoLink {
  position: number;
  label: string;
  path: string;
}

@Component({
  selector: 'vc-catalog-suggestions',
  templateUrl: './catalog-suggestions.component.html',
  styleUrls: ['./catalog-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogSuggestionsComponent implements OnInit, OnChanges {
  @Input()
  seoLinks: CatalogSeoLinksResponse;
  candidates: CatalogSeoLinkCandidates[];

  @Output() clickSeoLink = new EventEmitter<ISeoLink>();

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes) {
    if (!this.seoLinks || !this.seoLinks.data) {
      return;
    }

    this.candidates = this.seoLinks.data.candidates;
  }
}
